<section class="auth-wrapper auth-v1 px-2">
  <div [formGroup]="newUser" class="auth-inner py-2 form-custom-style">
    <div
      [ngClass]="{
        active:
          currentScreen.user.active &&
          (!currentScreen.user.onEnter || currentScreen.user.onEnter)
      }"
      class="user-card card mb-0"
    >
      <div class="card-body">
        <a class="brand-logo">
          <img
            src="../../../../../assets/images/pages/logo_white.png"
            alt="brand-logo"
            height="80"
          />
        </a>

        <h4 class="card-title mb-1">Create and account!</h4>
        <p class="card-text mb-2">
          Get started by creating your account on with us.
        </p>

        <form formGroupName="user" class="auth-login-form mt-2">
          <div class="form-group">
            <label for="username" class="form-label">Full name</label>
            <input
              type="text"
              formControlName="username"
              class="form-control"
              [placeholder]="'COMMON.ENTER_FIRST_NAME' | translate"
              aria-describedby="username"
              autocomplete="false"
              tabindex="1"
              id="username"
              [ngClass]="{
                'is-invalid':
                  getFormControl('user', 'username')?.invalid &&
                  getFormControl('user', 'username')?.dirty
              }"
            />
            <div
              *ngIf="
                getFormControl('user', 'username')?.invalid &&
                getFormControl('user', 'username')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Minimum characters required is 3 </small>
            </div>
          </div>

          <div class="form-group">
            <label for="user-email" class="form-label">Email</label>
            <input
              type="email"
              formControlName="email"
              class="form-control"
              placeholder="john@example.com"
              aria-describedby="user-email"
              autocomplete="false"
              tabindex="1"
              id="user-email"
              [ngClass]="{
                'is-invalid':
                  getFormControl('user', 'email')?.invalid &&
                  getFormControl('user', 'email')?.dirty
              }"
            />
            <div
              *ngIf="
                getFormControl('user', 'email')?.invalid &&
                getFormControl('user', 'email')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Invalid email address </small>
            </div>
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                formControlName="password"
                autocomplete="false"
                class="form-control form-control-merge"
                tabindex="2"
                placeholder="·········"
                id="password"
                aria-describedby="password"
                [ngClass]="{
                  'is-invalid error':
                    getFormControl('user', 'password')?.invalid &&
                    getFormControl('user', 'password')?.dirty
                }"
              />

              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"
                  ><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="passwordTextType = !passwordTextType"
                  ></i
                ></span>
              </div>
            </div>

            <div
              *ngIf="
                getFormControl('user', 'password')?.invalid &&
                getFormControl('user', 'password')?.dirty
              "
              class="invalid-feedback d-block"
            >
              <small> Password requires more than 3 characters </small>
            </div>
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-block flex items-center justify-center gap-2"
            tabindex="4"
            rippleEffect
            [disabled]="newUser.controls.user.invalid"
            (click)="toggleScreens('user')"
          >
            <span>Next</span>
            <i data-feather="arrow-right"></i>
          </button>
        </form>

        <p class="text-center mt-2">
          <span>Account already exist?</span>
          <a routerLink="/auth/login">
            <span>&nbsp;Login now</span>
          </a>
        </p>
      </div>
    </div>

    <div
      [ngClass]="{
        active: currentScreen.school.active && currentScreen.school.onEnter
      }"
      class="school-card card mb-0"
    >
      <div class="card-body">
        <a class="brand-logo">
          <img
            src="../../../../../assets/images/pages/logo_white.png"
            alt="brand-logo"
            height="80"
          />
        </a>

        <h4 class="card-title mb-1">Register a school!</h4>
        <p class="card-text mb-2">Continue by registering a school with us.</p>

        <form formGroupName="school" class="auth-login-form mt-2">
          <div class="form-group">
            <label for="school-name" class="form-label">School name</label>
            <input
              type="text"
              formControlName="name"
              class="form-control"
              [placeholder]="'COMMON.ENTER_INSTITUTION_NAME' | translate"
              aria-describedby="school-name"
              autocomplete="false"
              tabindex="1"
              id="school-name"
              [ngClass]="{
                'is-invalid':
                  getFormControl('school', 'name')?.invalid &&
                  getFormControl('school', 'name')?.dirty
              }"
            />
            <div
              *ngIf="
                getFormControl('school', 'name')?.invalid &&
                getFormControl('school', 'name')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Minimum characters is 3 </small>
            </div>
          </div>

          <div class="form-group">
            <label for="school-slug" class="form-label">School Abbreviation</label>
            <input
              type="text"
              formControlName="slug"
              class="form-control"
              [placeholder]="'COMMON.ENTER_INSTITUTION_NAME' | translate"
            />
            <div
              *ngIf="
                getFormControl('school', 'slug')?.invalid &&
                getFormControl('school', 'slug')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Minimum characters is 2 </small>
            </div>
          </div>

          <div class="form-group">
            <label for="school-contact-email" class="form-label"
              >School contact email</label
            >
            <input
              type="email"
              formControlName="contact_email"
              class="form-control"
              placeholder="info.smart@example.com"
              aria-describedby="school-contact-email"
              autocomplete="false"
              tabindex="1"
              id="school-contact-email"
              autofocus
              [ngClass]="{
                'is-invalid':
                  getFormControl('school', 'contact_email')?.invalid &&
                  getFormControl('school', 'contact_email')?.dirty
              }"
            />
            <div
              *ngIf="
                getFormControl('school', 'contact_email')?.invalid &&
                getFormControl('school', 'contact_email')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Invalid email </small>
            </div>
          </div>

          <div class="form-group">
            <label for="level" class="form-label">Education level</label>
            <p-dropdown appendTo="body" appendTo="body"
              formControlName="type"
              [options]="educationLevels"
              optionLabel="name"
              class=""
              id="level"
              [placeholder]="'COMMON.SELECT_LEVEL' | translate"
            ></p-dropdown>
            <div
              *ngIf="
                getFormControl('school', 'type')?.invalid &&
                getFormControl('school', 'type')?.dirty
              "
              class="invalid-feedback"
            >
              <small> Level is required </small>
            </div>
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-block flex items-center justify-center gap-3"
            tabindex="4"
            [disabled]="(loaderService._observer | async)?.isLoading || newUser.controls.school.invalid"
            rippleEffect
            (click)="createAccount()"
          >
            <div
              class="flex items-center justify-center gap-3"
              *ngIf="(loaderService._observer | async)?.isLoading"
            >
              <app-loader
                *ngIf="(loaderService._observer | async)?.isLoading"
              ></app-loader>

              <span *ngIf="(loaderService._observer | async)?.isLoading"
                >Processing</span
              >
            </div>

            <div
              class="flex items-center justify-center gap-3"
              *ngIf="!(loaderService._observer | async)?.isLoading"
            >
              <span>Submit</span>
              <i
                data-feather="send"
                *ngIf="!(loaderService._observer | async)?.isLoading"
              ></i>
            </div>
          </button>
        </form>

        <a (click)="toggleScreens('school')" class="text-center mt-2 back-btn">
          <i data-feather="arrow-left"></i>
          <span>&nbsp;Back</span>
        </a>
      </div>
    </div>
  </div>
</section>

<!--  -->

<!-- <section>
    <header>
        <div class="menuBar">
            <div class="logo">
                <img src="../../../../../assets/images/pages/logo.png" alt="logo.png"/>
            </div>
            <div class="smallNav">
                <h3>Register</h3>
            </div>
        </div>

    </header>
    <main>
        <div class="banner">
            <div class="sideBar">
                <div class="logo">
                    <img src="../../../../../assets/images/pages/logo.png" alt="logo.png"/>
                </div>
                <div class="sidebar-content">
                    <div class="paragraphSideBar">
                        <p>Focus on pedagogy let KingsSchool handle administration</p>
                    </div>
                    <div class="image">
                        <img src="../../../../../assets/images/pages/learner.png" alt="leaner.png"/>
                    </div>
                </div>

            </div>
            <div class="wrapper">
            <div class="head">
              <h3>Register 🚀</h3>
              <div class="smallHeading">
                  <h6> Preliminary Information  </h6>
                  <p>Let KingsSchool address you in a kind way.</p>

              </div>
              <div class="horizontalLine"></div>
              <div class="leftRight">
                <button (click)="nextPage = !nextPage" [disabled]="nextPage"  [ngClass]="{'active': !nextPage}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path fill-rule="evenodd" d="M7.28 7.72a.75.75 0 010 1.06l-2.47 2.47H21a.75.75 0 010 1.5H4.81l2.47 2.47a.75.75
                      0 11-1.06 1.06l-3.75-3.75a.75.75 0 010-1.06l3.75-3.75a.75.75 0 011.06 0z" clip-rule="evenodd" />
                    </svg>
                </button>
                <button (click)="nextPage = !nextPage"  [disabled]="!nextPage"   [ngClass]="{'active': nextPage}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" >
                      <path fill-rule="evenodd" d="M16.72 7.72a.75.75 0 011.06 0l3.75 3.75a.75.75 0 010 1.06l-3.75 3.75a.75.75
                      0 11-1.06-1.06l2.47-2.47H3a.75.75 0 010-1.5h16.19l-2.47-2.47a.75.75 0 010-1.06z" clip-rule="evenodd" />
                    </svg>
                </button>
               </div>
            </div>

                <div [formGroup]="newUser" >


                    <div class="form" [ngClass]="{'active': nextPage}">

                        <form formGroupName="user_info">

                            <div class="chooseProfile">
                                <div class="addedFile">
                                    <img [src]='imageObject.profile_photo' alt="profile_image" />
                                </div>

                                <input name="profile_photo" type='file'
                                       (change)="fileHandler($event, 'user_info')" id="getUserImage" style="display: none;">
                                <label  class="click"  for="getUserImage">
                                    <i class="feather icon-edit"></i>
                                    Choose Profile
                                </label>
                            </div>



                            <div class="inputElements">
                                <div class="labelInput">

                                    <div class="formFirstInput">
                                        <label class="formLabel" for="firstName">First Name</label>
                                        <input type="text" pInputText [placeholder]="'COMMON.ENTER_FIRST_NAME' | translate" id="firstName"
                                               formControlName="first_name"
                                               [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('user_info', 'first_name').invalid }">
                                        <small *ngIf="getFormControl('user_info', 'first_name').dirty &&
                                        getFormControl('user_info', 'first_name').invalid"
                                               class="p-error">First Name is Required</small>
                                    </div>

                                    <div class="formFirstInput">
                                        <label class="formLabel" for="lastName">Last Name</label>
                                        <input type="text" pInputText [placeholder]="'COMMON.ENTER_LAST_NAME' | translate" id="lastName"
                                               formControlName="last_name"
                                               [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('user_info', 'last_name').invalid }">
                                        <small *ngIf="getFormControl('user_info', 'last_name').invalid &&
                                        getFormControl('user_info', 'last_name').dirty"
                                               class="p-error">Last Name is Required</small>
                                    </div>


                                </div>

                                <div class="labelInput">

                                    <div class="formFirstInput">
                                        <label class="formLabel" for="email">Email</label>

                                        <input pInputText formControlName="email" type="email"
                                               [placeholder]="'COMMON.ENTER_EMAIL' | translate" id="email"
                                               [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('user_info', 'email').invalid }">
                                        <small *ngIf="getFormControl('user_info', 'email').invalid &&
                                        getFormControl('user_info', 'email').dirty"
                                               class="p-error">Email is Required</small>
                                    </div>

                                    <div class="formFirstInput">
                                        <label class="formLabel" for="phoneNumber">Phone Number</label>
                                        <input pInputText formControlName="phone_number" type="text"
                                               [placeholder]="'COMMON.ENTER_PHONE' | translate" id="phoneNumber"
                                               [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('user_info', 'phone_number').invalid }">
                                        <small *ngIf="getFormControl('user_info', 'phone_number').invalid &&
                                        getFormControl('user_info', 'phone_number').dirty"
                                               class="p-error">Phone Number is Required</small>
                                    </div>

                                </div>

                                <div class="labelInput">

                                    <div class="formFirstInput">
                                        <label class="formLabel" for="password">Password</label>
                                        <div class="p-input-icon-right">
                                            <button type="button" (click)="togglePasswordTextType()">
                                                <i [class]="!passwordTextType ? 'pi pi-eye': 'pi pi-eye-slash'"></i>
                                            </button>
                                            <input pInputText formControlName="password"  [type]="passwordTextType ? 'text' : 'password'"
                                                   id="password" [placeholder]="'COMMON.ENTER_NEW_PASSWORD' | translate"
                                                   [ngClass]="{ 'ng-invalid ng-dirty':
                                                   getFormControl('user_info', 'password').invalid }">
                                        </div>
                                        <small *ngIf="getFormControl('user_info', 'password').invalid &&
                                        getFormControl('user_info', 'password').dirty"
                                               class="p-error">Password is Required</small>
                                    </div>

                                    <div class="formFirstInput">
                                        <label class="formLabel" for="confirmPassword">Confirm Password</label>
                                        <div class="p-input-icon-right">
                                            <button type="button" (click)="togglePasswordTextType()">
                                                <i [class]="!passwordTextType ? 'pi pi-eye': 'pi pi-eye-slash'"></i>
                                            </button>
                                            <input pInputText formControlName="c_password"  [type]="passwordTextType ? 'text' : 'password'"
                                                   id="confirmPassword" [placeholder]="'COMMON.CONFIRM_NEW_PASSWORD' | translate"
                                                   [ngClass]="{ 'ng-invalid ng-dirty':
                                                   getFormControl('user_info', 'c_password').invalid }">
                                        </div>


                                        <small *ngIf="getFormControl('user_info', 'c_password').invalid &&
                                        getFormControl('user_info', 'c_password').dirty &&
                                        !getFormControl('user_info', 'password').dirty"
                                               class="p-error">Confirm Password is Required</small>

                                        <small *ngIf="getFormControl('user_info', 'c_password').dirty &&
                                        getFormControl('user_info', 'password').value !==
                                        getFormControl('user_info', 'c_password').value" class="p-error">
                                            Password does not match
                                        </small>
                                    </div>

                                </div>
                            </div>


                            <div class="forgotAndCreat">
                                <p>
                                    <span> Already have an account? </span>
                                    <a routerLink="/login">
                                        <span>&nbsp;Login </span>
                                    </a>
                                </p>
                                <button class="login" (click)="nextPage = !nextPage"> Proceed </button>
                            </div>
                        </form>
                    </div>

                    <div class="form" [ngClass]="{'slideOut': !nextPage}">


                        <form formGroupName="school">

                            <div class="chooseProfile">
                                <div class="addedFile">
                                   <img [src]="imageObject.logo" alt="institution_logo" />
                                </div>
                                <input name="logo" type='file'
                                       (change)="fileHandler($event, 'school')" id="instImg" style="display: none;">
                                <label  class="click" for="instImg">
                                    <i class="feather icon-edit"></i>
                                    Choose Image
                                </label>
                            </div>

                            <div class="inputElements">
                                <div class="labelInput">


                                    <div class="formFirstInput">
                                        <label class="formLabel" for="instName">Institution Name</label>
                                        <input pInputText [placeholder]="'COMMON.ENTER_INSTITUTION_NAME' | translate" id="instName"
                                               formControlName="name" type="text"
                                               [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('school', 'name').invalid }">
                                        <small *ngIf="getFormControl('school', 'name').dirty &&
                                        getFormControl('school', 'name').invalid"
                                               class="p-error">Institution Name is Required</small>
                                    </div>

                                    <div class="formFirstInput">
                                        <label class="formLabel" for="instPhn">Institution Phone Number</label>

                                        <input pInputText [placeholder]="'COMMON.ENTER_INSTITUTION_PHONE' | translate" type="text" id="instPhn"
                                               formControlName="contact_phone" [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('school', 'contact_phone').invalid }">
                                        <small *ngIf="getFormControl('school', 'contact_phone').dirty &&
                                        getFormControl('school', 'contact_phone').invalid"
                                               class="p-error">Institution's contact Tel is Required</small>
                                    </div>
                                </div>

                                <div class="labelInput">
                                    <div class="formFirstInput col-span-2">
                                        <label class="formLabel" for="instEmail">Institution Email</label>

                                        <input pInputText [placeholder]="'COMMON.ENTER_INSTITUTION_EMAIL' | translate" id="instEmail"
                                               formControlName="contact_email" type="email" [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('school', 'contact_email').invalid }">
                                        <small *ngIf="getFormControl('school', 'contact_email').dirty &&
                                        getFormControl('school', 'contact_email').invalid"
                                               class="p-error">Institution's contact email is Required</small>
                                    </div>

                                </div>

                                <div class="labelInput">

                                    <div class="formFirstInput">
                                        <label class="formLabel"  for="instLevel">Institution Level</label>
                                        <p-dropdown appendTo="body" [options]="level" id="instLevel" formControlName="type"  [filter]="true"
                                                    filterBy="name" [showClear]="true" placeholder="Select a Level">
                                            <ng-template pTemplate="selectedItem">
                                                    <div *ngIf="getFormControl('school', 'type').value">
                                                        {{getFormControl('school', 'type').value?.name}}
                                                    </div>
                                            </ng-template>
                                            <ng-template let-level pTemplate="item">
                                                    <div>{{level.name}}</div>
                                            </ng-template>
                                        </p-dropdown>
                                    </div>

                                    <div class="formFirstInput">
                                        <label class="formLabel"  for="instLocation">Institution Location (country - city - street)</label>
                                        <input pInputText [placeholder]="'COMMON.ENTER_INSTITUTION_LOCATION' | translate" id="instLocation"
                                               formControlName="address" type="text" [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('school', 'address').invalid }">
                                        <small *ngIf="getFormControl('school', 'address').dirty &&
                                        getFormControl('school', 'address').invalid"
                                               class="p-error">Institution's address is invalid</small>
                                    </div>
                                </div>

                                <div class="labelInput">

                                    <div class="formFirstInput col-span-2">
                                        <label class="formLabel" for="instDescription">Institution Description</label>

                                        <textarea pInputText [placeholder]="'COMMON.DESCRIBE_INSTITUTION' | translate" id="instDescription"
                                               formControlName="description" [ngClass]="{ 'ng-invalid ng-dirty':
                                               getFormControl('school', 'description').invalid }"></textarea>
                                        <small *ngIf="getFormControl('school', 'description').dirty &&
                                        getFormControl('school', 'description').invalid"
                                               class="p-error">Institution's contact email is Required</small>
                                    </div>


                                </div>

                            </div>
                           <div class="forgotAndCreat">
                                <p>
                                    <span> Already have an account? </span>
                                    <a routerLink="/login">
                                        <span>&nbsp;Login </span>
                                    </a>
                                </p>
                                    <button class="login" (click)="createAccount()"> Finish </button>
                            </div>
                        </form>
                    </div>

                </div>

            </div>
        </div>
    </main>
</section> -->
